IREP.VideoTracking = (function () {
    var beginLog = false;
    var endLog = false;

    var media_properties = ["currentTime", "duration"];

    var init = function (videoID) {
        beginLog = false;
        endLog = false;
        middleLog = false;

        document._video = document.getElementById(videoID)
        
        if (document._video.getElementsByTagName("source").length > 0) {
            document._video.addEventListener("durationchange", IREP.VideoTracking.capture, false);
            document._video.addEventListener("timeupdate", IREP.VideoTracking.capture, false);
        }
    };

    var capture = function (event) {
        
        if ((document._video.currentTime < 5) && !beginLog) {
            logVideo(1)

            beginLog = true
        } else if ((document._video.currentTime > (document._video.duration / 2)) && !middleLog) {
            logVideo(3)
            middleLog = true
        } else if ((document._video.currentTime > (document._video.duration - 5)) && !endLog) {
            logVideo(2)

            endLog = true
        }
    };

    var logVideo = function (ViewType) {
        var vuid

        if (document._video.getElementsByTagName("source")[0].dataset != null) {
            vuid = document._video.getElementsByTagName("source")[0].dataset.videouid;
        } else {
            vuid = document._video.getElementsByTagName("source")[0].getAttribute("data-videoUID")
        }
        
        $.ajax({
            type: "POST",
            url: "https://retailedge.intel.com/FlashDX/PostStatsURL.aspx?TS=" + new Date().getTime(),
            data: { videoResultsXML: '<?xml version="1.0" encoding="utf-8" ?><Video ID="' + vuid + '" ParticipantID="' + IREP.options.user.currentUID + '" ViewType="' + ViewType + '" Source="null"/>' }
        })
    }

    return {
        init: init,
        capture: capture,
    };
})();

